"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const QuotationList_vue_1 = __importDefault(require("../../pages/quote/QuotationList.vue"));
exports.default = [
    {
        name: 'quotation_list',
        path: '/queries/quotation-list',
        component: QuotationList_vue_1.default,
        meta: { requiresAuth: true, title: 'Quotation List' }
    },
    {
        name: 'quotations_api',
        path: '/api/quotations/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'create_quotation_api',
        path: '/api/carts/:id(\\d+)?/create-quotation',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'quotation_pdf_api',
        path: '/uploads/quotations/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    }
];
